<div class="ey-font">{{ data.title }}</div>
<div>
  @for (message of data.messages; track message) {
    <span [ngClass]="data.confirm && data.onYes ? 'reset' : 'confirm'"
      class="ey-font" [innerHTML]="message"></span>
  }
</div>
<div class="f-right">
  @if (!data.confirm) {
    <a (click)="onCancel()" class="ey-secondary-dark">Okay</a>
  }

  @if (data.confirm && data.onYes) {
    <a (click)="data.onNo(); onCancel()" class="ey-secondary-dark me-3">No</a>
    <a (click)="data.onYes(); onConfirm()" class="ey-button-dark mr-2">Yes</a>
  }
  @if (data.confirm && !data.onNo) {
    <a (click)="onNoClick()" class="ey-secondary-dark mr-2">No</a>
  }
  @if (data.confirm && !data.onYes) {
    <a (click)="OnYesClick()" class="ey-button-dark">Yes</a>
  }
</div>